var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.776,
    height: 24.966,
    viewBox: "0 0 13.776 24.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.05 0.05)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M855.943,312.9H846a1.866,1.866,0,0,1-1.865-1.865V289.894A1.866,1.866,0,0,1,846,288.029h9.946a1.867,1.867,0,0,1,1.865,1.865V311.03A1.867,1.867,0,0,1,855.943,312.9ZM846,289.272a.621.621,0,0,0-.622.622V311.03a.622.622,0,0,0,.622.622h9.946a.623.623,0,0,0,.622-.622V289.894a.622.622,0,0,0-.622-.622Z",
    transform: "translate(-844.132 -288.029)",
    fill: "#e52431",
    stroke: "#e52431",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.737,291.471h-2.884a.721.721,0,0,1,0-1.442h2.884a.721.721,0,1,1,0,1.442Z",
    transform: "translate(-843.11 -287.145)",
    fill: "#e52431",
    stroke: "#e52431",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.574,290.75a.721.721,0,1,1-.721-.721A.722.722,0,0,1,847.574,290.75Z",
    transform: "translate(-843.322 -287.145)",
    fill: "#e52431",
    stroke: "#e52431",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.3,307.355a2.163,2.163,0,1,1,2.163-2.163A2.165,2.165,0,0,1,850.3,307.355Zm0-2.884a.721.721,0,1,0,.721.721A.72.72,0,0,0,850.3,304.471Z",
    transform: "translate(-843.11 -285.373)",
    fill: "#e52431",
    stroke: "#e52431",
    strokeWidth: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.39a6efebc68c1ec4cf6c522722b569a7.svg";
export { ForwardRef as ReactComponent };